import { render, staticRenderFns } from "./VsTableM.vue?vue&type=template&id=01fb9591"
import script from "./VsTableM.vue?vue&type=script&lang=js"
export * from "./VsTableM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports